<template>
    <v-app class="login-page">
        <v-main class="login-wrapper">

            <!-- Left Pane (Desktop Only) -->
            <div class="login-left">
                <img src="@/assets/image.png" class="bg-image" />
                <img src="@/assets/logo_white.png" class="logo" />
            </div>

            <!-- Right Pane -->
            <div class="login-right">
                <div class="login-form">

                    <!-- Header -->
                    <div class="mb-8">
                        <img src="../assets/logo.png" class="logo-img" alt="Crowdital Logo" />
                        <h3 class="text-2xl font-semibold text-gray-900 mt-8">
                            Verify 2FA Code
                        </h3>
                        <p class="text-gray-400 text-xs mt-2">
                            Enter the code sent to your email
                        </p>
                    </div>

                    <!-- Form -->
                    <form @submit.prevent="handleLogin" class="w-full space-y-6">

                        <!-- Email -->
                        <div class="flex flex-col gap-2 spacing text-left">
                            <label class="text-sm font-medium text-gray-700 text-left">Enter 2FA Code</label>
                            <input v-model="code" type="text" required placeholder="e.g 123456"
                                class="modern-input" />
                        </div>

                        <!-- Submit -->
                        <button type="submit" @click="verify" :disabled="loading" class="login-button mb-4">
                            <span v-if="!loading">Verify 2FA Code <v-icon
                                    start>mdi-sync</v-icon></span>
                            <span v-else>Processing... <v-icon start class="spin">mdi-loading</v-icon></span>
                        </button>
                        <!-- <p>Or, return to
                            <button type="button" @click="signin"
                                class="text-sm font-medium text-green hover:text-black transition-colors">
                                Login
                            </button>
                            
                        </p> -->

                        <p class="text-center mt-4">
                            Didn't receive the code?
                            <button type="button" @click="resendOtp" :disabled="resendLoading"
                                class="text-sm font-medium text-green hover:text-black transition-colors disabled:opacity-50">
                                {{ resendLoading ? 'Resending...' : 'Resend OTP' }}
                            </button>

                            <br />

                            <span class="text-grey">or</span>

                            <button type="button" @click="signin"
                                class="text-sm font-medium text-green hover:text-black transition-colors ml-1">
                                Return to Login
                            </button>
                        </p>
                    </form>
                    <v-snackbar v-model="snackbar.show" :color="snackbar.color" timeout="3000" location="top right"> {{
                        snackbar.message }}
                        <template #actions>
                            <v-btn variant="text" @click="snackbar.show = false">
                                Close
                            </v-btn>
                        </template>
                    </v-snackbar>
                </div>
            </div>

        </v-main>
    </v-app>
</template>

<script setup>
import { ref } from "vue"
import { useRouter, useRoute } from "vue-router"
import { verify2fa, sendOtp } from "@/api/auth"
import { getAllErrors } from "@/util"

const router = useRouter()
const route = useRoute()

const error = ref("")
const code = ref("")
const loading = ref(false)
const resendLoading = ref(false)

console.log('user_id', route.query.user_id)

//snack bar notification
const snackbar = ref({
    show: false,
    message: "",
    color: "success" // success | error | warning | info
})

const showSnackbar = (message, color = "success") => {
    snackbar.value.message = message
    snackbar.value.color = color
    snackbar.value.show = true
}

const verify = async () => {
    error.value = ""
    loading.value = true

    if (code.value.length == "") {
        showSnackbar(
            "Please input a total of 6 digits",
            "error"
        )
        return
    }
    try {
        const res = await verify2fa({
            user_id: route.query.user_id,
            code: code.value
        })

        showSnackbar("2FA verified", "success")

        localStorage.setItem("token", res.data.data.token)
        localStorage.removeItem("two_factor_token")

        setTimeout(() => {
            router.push("/dashboard")
        }, 1000)

    } catch (e) {
        const msg = getAllErrors(e)
        //console.log(e.response?.data)
        showSnackbar(
            msg || "Invalid 2FA code",
            "error"
        )
        error.value = e.response?.data?.message || "Unable to verify 2FA code"
    } finally {
        loading.value = false
    }
}

const signin = () => {
    router.push("/login")
}

const resendOtp = async () => {
  resendLoading.value = true

  try {
    const payload = {
      user_id: route.query.user_id,
    }

    await sendOtp(payload)

    showSnackbar("A new OTP has been sent successfully", "success")
  } catch (error) {
    const msg = getAllErrors(error)

    showSnackbar(
            msg || "Unable to resend OTP. Please try again.",
            "error"
        )
  } finally {
    resendLoading.value = false
  }
}
</script>

<style scoped>
/* Layout */
.login-wrapper {
    display: flex;
    min-height: 100vh;
}

.login-left {
    flex: 1;
    position: relative;
    overflow: hidden;
}

.bg-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.logo-img {
    width: 20em;
}

.logo {
    position: absolute;
    bottom: 24px;
    left: 24px;
    width: 130px;
}

.login-right {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #f9fafb;
    padding: 24px;
}

.login-form {
    width: 100%;
    max-width: 420px;
}

/* Inputs */
.modern-input {
    width: 100%;
    height: 46px;
    margin-top: 6px;
    padding: 10px 14px;
    border-radius: 10px;
    border: 1px solid #d1d5db;
    font-size: 15px;
    background: transparent;
    transition: all 0.2s ease;
}

.modern-input:focus {
    outline: none;
    border-color: #000;
    box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.1);
}

/* Button */
.login-button {
    width: 100%;
    height: 46px;
    background: #000;
    color: #fff;
    border-radius: 10px;
    font-weight: 600;
    transition: all 0.25s ease;
}

.login-button:hover {
    background: #292828;
}

.login-button:disabled {
    opacity: 0.7;
    cursor: not-allowed;
}

.spacing {
    margin-bottom: 1em;
}

.m-space {
    margin-left: 9.5rem !important;
}

.modern-input.pr-10 {
    padding-right: 2.5rem;
    /* enough space for eye button */
}

.relative {
    position: relative;
}

/* Button positioned over the input */
.absolute {
    position: absolute;
    cursor: pointer;
}
.spin {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

/* Mobile */
@media (max-width: 767px) {
    .login-wrapper {
        flex-direction: column;
    }

    .login-left {
        display: none;
    }

    .m-space {
        margin-left: 7rem !important;
    }
}
</style>
